/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Reference_Method_DxaInputs */

const en_us2_body_assessment_reference_method_dxa = /** @type {(inputs: Body_Assessment_Reference_Method_DxaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DXA`)
};

const pt_br2_body_assessment_reference_method_dxa = /** @type {(inputs: Body_Assessment_Reference_Method_DxaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DEXA`)
};

const es_419_body_assessment_reference_method_dxa = /** @type {(inputs: Body_Assessment_Reference_Method_DxaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DXA`)
};

const pt_pt2_body_assessment_reference_method_dxa = /** @type {(inputs: Body_Assessment_Reference_Method_DxaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DEXA`)
};

const fr_fr2_body_assessment_reference_method_dxa = /** @type {(inputs: Body_Assessment_Reference_Method_DxaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DXA`)
};

const de_de2_body_assessment_reference_method_dxa = /** @type {(inputs: Body_Assessment_Reference_Method_DxaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DXA`)
};

const it_it2_body_assessment_reference_method_dxa = /** @type {(inputs: Body_Assessment_Reference_Method_DxaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DXA`)
};

/**
* | output |
* | --- |
* | "DXA" |
*
* @param {Body_Assessment_Reference_Method_DxaInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_reference_method_dxa = /** @type {((inputs?: Body_Assessment_Reference_Method_DxaInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Reference_Method_DxaInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_reference_method_dxa(inputs)
	if (locale === "es-419") return es_419_body_assessment_reference_method_dxa(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_reference_method_dxa(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_reference_method_dxa(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_reference_method_dxa(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_reference_method_dxa(inputs)
	return en_us2_body_assessment_reference_method_dxa(inputs)
});
export { body_assessment_reference_method_dxa as "body-assessment.reference_method.dxa" }